import React, { useState, forwardRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./Header.module.scss";
import classNames from "classnames";
import Logo from "../components/Logo";
import { useSelector, useDispatch } from "react-redux";
import Avatar from "./../components/Avatar";
import { Logout, ToggleDepositModal /* toggleSidebar */ } from "./../store/actions/app.js";
import { CleanAssets } from "./../store/actions/assets";
import { Divider, IconButton, Button, Menu, MenuItem } from "@mui/material";
import { DotsHorizontal } from "mdi-material-ui";

const ForwardNavLink = forwardRef((props, ref) => (
  <NavLink {...props} innerRef={ref} />
));

const Header = (props) => {
  // state
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [marketingMenuAnchor, setMarketingMenuAnchor] = useState(null);
  const [balance, setBalance] = useState(0);
  // redux
  const { loggedin, user } = useSelector((state) => state.app);
  const { list, loading } = useSelector((state) => state.balance);
  const dispatch = useDispatch();

  useEffect(() => {
    if(loggedin && !loading) {
      const findBalance = list.find(item => {
        return item.asset.symbol === "tether"
      });
      if(findBalance) {
        setBalance(findBalance.amount);
      }
    }
  },[loggedin,loading,list])

  // methods
  const handleUserMenuToggle = (e) => {
    setUserMenuAnchor(e.currentTarget);
  };
  const handleMarketingMenuToggle = (e) => {
    setMarketingMenuAnchor(e.currentTarget);
  };
  const handleLogout = () => {
    dispatch(Logout());
    dispatch(CleanAssets());
  };
  

  return (
    <div className={classNames(styles["header"], "container-fluid", props.pathname === "/" && styles["hero"])}>
      <div className="row align-items-center h-100">
        <div className="col-4">
          <Logo />
        </div>
        <div className="col-8 justify-content-end d-flex align-items-center">
          <IconButton className="p-0 me-3 d-none" onClick={handleMarketingMenuToggle}>
            <DotsHorizontal/>
          </IconButton>
          {
            (loggedin && !loading ) && (
              <>
                <div className={classNames(styles["balance"], "me-2")}>
                  <Button 
                    size="small" 
                    variant="outlined" 
                    onClick={() => {
                      dispatch(ToggleDepositModal(true, 0));
                    }}
                    >{
                    balance.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })
                  }</Button>
                </div>
              </>
            )
          }
          <Menu
            variant="menu"
            anchorEl={marketingMenuAnchor}
            keepMounted={false}
            open={Boolean(marketingMenuAnchor)}
            onClose={() => setMarketingMenuAnchor(null)}
            disableScrollLock={true}
          >
            <MenuItem
              component={ForwardNavLink}
              to={"/impact-investing"}
              onClick={() => setMarketingMenuAnchor(null)}
            >
              Impact Investing
            </MenuItem>
            <MenuItem
              component={ForwardNavLink}
              to={"/offset-emissions"}
              onClick={() => setMarketingMenuAnchor(null)}
            >
              Offset Your Emissions
            </MenuItem>
            <MenuItem
              component={ForwardNavLink}
              to={"/supply"}
              onClick={() => setMarketingMenuAnchor(null)}
            >
              Supply Carbon Credits
            </MenuItem>
          </Menu>
          {loggedin ? (
            <>
              <IconButton className="p-0" onClick={handleUserMenuToggle}>
                <Avatar user={user} size={33} link={false}/>
              </IconButton>
              <Menu
                variant="menu"
                anchorEl={userMenuAnchor}
                keepMounted={false}
                open={Boolean(userMenuAnchor)}
                onClose={() => setUserMenuAnchor(null)}
              >
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/trades"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Trades
                </MenuItem>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/deposits"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Deposits
                </MenuItem>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/withdrawals"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Withdrawals
                </MenuItem>
                <Divider/>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/profile"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Profile
                </MenuItem>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/bank"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  My Bank Accounts
                </MenuItem>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/dashboard/security"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Security
                </MenuItem>
                <Divider />
                <MenuItem
                  component={ForwardNavLink}
                  to={"/otc-desk"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  OTC Desk
                </MenuItem>
                <MenuItem
                  component={ForwardNavLink}
                  to={"/otc-desk#contact-us"}
                  onClick={() => setUserMenuAnchor(null)}
                >
                  Contact Us
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setUserMenuAnchor(null);
                    handleLogout();
                  }}
                >
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <Button
              color="primary"
              variant="contained"
              disableElevation={true}
              component={Link}
              to="/login"
              size="small"
              sx={{
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "#0757cb",
                  color: "#fff"
                }
              }}
            >
              Login
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
export default Header;
